import { WarningIcon } from '@assets/svgs/WarningIcon'

import type { WarningBannerProps } from './types'

import * as S from './styles'

/**
 * Banner de aviso exibido no topo das telas.
 * Não renderiza nada quando `message` vem nulo/vazio da API.
 */
export const WarningBanner = ({ message, marginTop = 24, style, ...props }: WarningBannerProps) => {
  if (!message) return null

  return (
    <S.WarningBanner style={{ marginTop: marginTop as number, ...style }} {...props}>
      <S.WarningIconContainer>
        <WarningIcon />
      </S.WarningIconContainer>

      <S.WarningText>{message}</S.WarningText>
    </S.WarningBanner>
  )
}
